<template>
    <Admin style="background: white">
      <v-main v-if="!isProductListLoading" class="wrapper">
        <v-container v-if="!selectedCompanyProductList?.isNsThaiSmartTax" fluid>
          You are not allowed for this feature, Please contact Sales
          <a href="tel:026637895" target="_blank"
            ><b><u>026637895</u></b></a
          >
        </v-container>
        <v-container v-else fluid>
          Please contact Sales
          <a href="tel:026637895" target="_blank"
            ><b><u>026637895</u></b></a
          >
        </v-container>
      </v-main>
      <v-main v-else>
        <div class="tw-flex tw-justify-center tw-mt-20">
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>
      </v-main>
    </Admin>
  </template>
  
  <script>
  import Admin from "@/components/admin/admin-main-template";
  import { mapState } from "vuex";
  const _ = require("lodash");
  
  export default {
    data() {
     
    },
    name: "ReportThaiTax",
    components: {
      Admin,
    },
    methods: {
   
    },
    computed: mapState({
      selectedCompanyProductList: (state) =>
        state.companies.selectedCompanyProductList,
      isProductListLoading: (state) => state.companies.isProductListLoading,
     
    }),
  
  };
  </script>
  
  <style lang="css" scoped>
  .table-container {
    padding: 1rem;
  }
  
  table {
    width: 100%;
    table-layout: fixed;
  }
  
  .tr-gray {
    background-color: hsla(0, 0%, 62%, 0.149);
  }
  
  .tr-gray-low {
    background-color: hsla(0, 0%, 79%, 0.094);
  }
  
  .bot-bg {
    background-color: #133265;
  }
  
  .kbank-bg {
    background-color: #00a94f;
  }
  
  .ktb-bg {
    background-color: #01a6e6;
  }
  
  .bcel-bg {
    background-color: #ec1c24;
  }
  
  .bbl-bg {
    background-color: #0065fe;
  }
  
  .scb-bg {
    background-color: #4e2a82;
  }
  .uob-bg {
    background-color: #05377b;
  }
  
  .detail-table {
    /* border: 2px solid red; */
    height: 60vh;
    overflow-y: auto;
    /* Scrollbar customization */
    /* scrollbar-width: 5px; */
  }
  
  /* For WebKit browsers (Chrome, Safari, etc.) */
  .detail-table::-webkit-scrollbar {
    width: 3px;
  }
  
  .detail-table::-webkit-scrollbar-track {
    background: rgba(231, 231, 231, 0.5);
  }
  
  .detail-table::-webkit-scrollbar-thumb {
    background-color: rgb(133, 133, 133);
    border-radius: 20px;
    border: transparent;
  }
  
  .table-container table {
    width: 100%;
    margin-bottom: 2rem;
  }
  
  .table-container th {
    padding: 8px 5px;
    text-align: left;
    color: #fff;
  }
  
  /* Styling for table cells */
  .table-container td {
    padding: 10px;
    height: 60px;
  }
  </style>
  